import React from 'react';
import classes from './PostQueueStat.module.scss';
import { IconsEnum } from '../../../constants/icons';
import { Icon } from '../../images/Icon/Icon';
import classNames from 'classnames';
import { useInView } from 'react-intersection-observer';

export type PostQueueStatIconsType =
  | IconsEnum.boost
  | IconsEnum.clicks
  | IconsEnum.cycles
  | IconsEnum.comments
  | IconsEnum.impressions
  | IconsEnum.iteration
  | IconsEnum.likes
  | IconsEnum.share
  | IconsEnum.videoViews
  | IconsEnum.retweets;

export enum PostQueueStatLabelsEnum {
  boost = 1,
  clicks,
  cycles,
  comments,
  impressions,
  iteration,
  likes,
  share,
  videoViews,
  retweets
}

const mapPostQueueStatLabelsEnumToIconsEnum = (
  label: PostQueueStatLabelsEnum
): { icon: PostQueueStatIconsType; label: string } => {
  switch (label) {
    case PostQueueStatLabelsEnum.boost:
      return { icon: IconsEnum.boost, label: 'Boost' };
    case PostQueueStatLabelsEnum.clicks:
      return { icon: IconsEnum.clicks, label: 'Clicks' };
    case PostQueueStatLabelsEnum.cycles:
      return { icon: IconsEnum.cycles, label: 'Cycles' };
    case PostQueueStatLabelsEnum.comments:
      return { icon: IconsEnum.comments, label: 'Comments' };
    case PostQueueStatLabelsEnum.impressions:
      return { icon: IconsEnum.impressions, label: 'Impressions' };
    case PostQueueStatLabelsEnum.iteration:
      return { icon: IconsEnum.cycles, label: 'Iterations' };
    case PostQueueStatLabelsEnum.likes:
      return { icon: IconsEnum.likes, label: 'Likes' };
    case PostQueueStatLabelsEnum.share:
      return { icon: IconsEnum.share, label: 'Shares' };
    case PostQueueStatLabelsEnum.videoViews:
      return { icon: IconsEnum.videoViews, label: 'Views' };
    case PostQueueStatLabelsEnum.retweets:
      return { icon: IconsEnum.retweets, label: 'Retweets' };
  }
};

// Currently only used by Discover PostCard
export enum PostQueueStatSizeEnum {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE'
}

export type PostQueueStatProps =
  | {
      showBarGraph: false;
      scale?: never;
    }
  | {
      showBarGraph: true;
      scale: number; // The number which is equivalent to 100%
    };

export type PostQueueStatViewProps = {
  label: PostQueueStatLabelsEnum;
  value: number;
  hideLabel?: boolean;
  size?: PostQueueStatSizeEnum;
  isDisabled?: boolean;
} & PostQueueStatProps;

export const PostQueueStatView = (props: PostQueueStatViewProps): JSX.Element => {
  const { ref, inView } = useInView({
    threshold: 1
  });
  const { label, icon } = mapPostQueueStatLabelsEnumToIconsEnum(props.label);
  const percentage = !props.showBarGraph ? 0 : (props.value / props.scale) * 100;

  const postQueueStatClasses = classNames(classes.PostQueueStat, {
    [classes.PostQueueStatHidden]: !inView,
    [classes.PostQueueStatDisabled]: props.isDisabled
  });
  const statsValueClasses = classNames(classes.PostQueueStatValue, classes[`PostQueueStatValue${props.size}`]);
  const labelClasses = classNames(classes.PostQueueStatLabel, classes[`PostQueueStatLabel${props.size}`]);

  return (
    <div ref={ref}>
      <div className={postQueueStatClasses}>
        <div className={statsValueClasses}>
          <Icon name={icon} size={'medium'} />
          {props.label === PostQueueStatLabelsEnum.boost && <>x</>}
          {props.value}
        </div>
        {!props.hideLabel && <div className={labelClasses}>{label}</div>}
        {props.showBarGraph && (
          <div className={classes.PostQueueStatGraphBar}>
            <div className={classes.GraphFill} style={{ width: `${percentage}%` }} />
          </div>
        )}
      </div>
    </div>
  );
};
